
















import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import CategoryMedia from '@/components/media/CategoryMedia.vue'

@Component({
  components: {
    CategoryMedia
  }
})
export default class QuestionList extends Vue {
  @Prop(Array) public askedQuestionsList!: Array<String>

  get selectedFriend () {
    return this.$store.getters['selectedFriend']
  }

  get settings () {
    return this.$store.getters['settings']
  }

  @Watch('askedQuestionsList')
  protected scrollToEnd () {
    this.$nextTick(() => {
      this.$el.scrollTop = this.$el.scrollHeight
    })
  }
}
